// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RankButton-module__rank___kuhpF svg{width:21px;height:21px}.RankButton-module__rank___kuhpF.RankButton-module__rankSelected___qwOP4 svg,.RankButton-module__rank___kuhpF:hover svg{fill:#f62bfd}", "",{"version":3,"sources":["webpack://./src/components/search/Spark/LeftMeta/RankButton/RankButton.module.scss"],"names":[],"mappings":"AACE,qCACE,UAAA,CACA,WAAA,CAKA,wHACE,YAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rank": "RankButton-module__rank___kuhpF",
	"rankSelected": "RankButton-module__rankSelected___qwOP4"
};
export default ___CSS_LOADER_EXPORT___;
